/**
 * Umwandlung zwischen Formularfeld und Datenmodell.
 *
 * React Hook Form ruft `setValueAs` nicht nur bei Eingaben auf, sondern auch
 * beim Registrieren eines Feldes — und übergibt dort `null`, wenn es keinen
 * Vorgabewert gibt. Diese Funktionen müssen deshalb mit allem umgehen, was
 * hereinkommen kann, nicht nur mit dem, was der Nutzer tippt.
 */

/**
 * Optionaler Text.
 *
 * Leer muss als `undefined` beim Server ankommen, niemals als `''`: Auf der
 * Fahrgestellnummer liegt ein Unique-Index, und Postgres erlaubt beliebig viele
 * NULL, aber nur einen Leerstring. Das zweite Fahrzeug ohne FIN käme sonst als
 * Konflikt zurück.
 */
export function toOptionalText(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed === '' ? undefined : trimmed;
}

/** Optionale Ganzzahl aus einem Zahlenfeld. */
export function toOptionalNumber(value: unknown): number | undefined {
  // Vorgabewerte kommen bereits als Zahl herein und dürfen nicht verlorengehen.
  if (typeof value === 'number') return Number.isNaN(value) ? undefined : value;
  if (typeof value !== 'string') return undefined;

  const trimmed = value.trim();
  if (trimmed === '') return undefined;

  const parsed = Number(trimmed);
  // NaN bewusst durchreichen — daraus macht Zod eine Meldung am Feld.
  return parsed;
}

/*
 * Hier stand einmal `toPriceCent`.
 *
 * Es unterschied Zahl von Zeichenkette, um den Vorgabewert nicht ein zweites Mal
 * mit hundert zu multiplizieren — eine Abwehr gegen ein Feld, das nicht wusste,
 * ob es gerade Euro oder Cent enthielt. Die Unklarheit war das Problem, nicht die
 * fehlende Abwehr: Das Preisfeld führt seinen Euro-Text inzwischen als eigenen
 * Anzeigezustand und ruft `parseEuroToCent` unmittelbar auf. Damit gibt es keinen
 * Weg mehr, auf dem ein Cent-Betrag als Euro-Eingabe ankäme.
 */
